import { classNames } from '@repo/ui/src/utils/classNames';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import EssentialLineItem from './_EssentialLineItem';
import Product from '@models/product';
import LoadingLogo from '@components/Loading/LoadingLogo';
import React from 'react';

interface Props {
  handleSelect: (sku: string) => void;
  loading: boolean;
  label?: string;
  addons?: Array<Product>;
  dark?: boolean;
  step?: number | `${number}`;
}

const EssentialOrSaleItems = ({ handleSelect, loading, label, addons, dark, step }: Props) => {
  const { t } = useTranslation();

  if (!addons?.length) {
    return null;
  }

  return (
    <div className="tw-pt-2 tw-pb-4 tw-grid tw-gap-2">
      <h4 className={classNames('tra-text-web-utl-link tw-pb-2', dark && 'tw-text-white')}>
        0{step} -{' '}
        {label ??
          t('productDetailPageContent.essentialsText', undefined, {
            default: 'Add Essentials',
          })}
      </h4>
      {loading ? (
        <div className="tw-flex tw-place-center">
          <LoadingLogo />
        </div>
      ) : (
        addons.map((addon) => (
          <EssentialLineItem
            handleSelect={() => handleSelect(addon.sku)}
            product={addon}
            key={addon.sku}
            selected={addon.checked}
          />
        ))
      )}
    </div>
  );
};

export default EssentialOrSaleItems;
